import tw from 'twin.macro';

const Select = tw.select`rounded-lg border-2 bg-gray-50 py-2 px-3 focus:(border-primary outline-none) disabled:(bg-gray-200 text-gray-600)`;

export default Select;
